(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    const slider = document.querySelector('[data-announcement-slider]');
    if (!slider || slider.children.length <= 1) return;
    const slides = Array.from(slider.children);
    let index = 0;
    function showNext() {
      slides[index].style.display = 'none';
      index = (index + 1) % slides.length;
      slides[index].style.display = '';
    }
    slides.forEach((s, i) => { s.style.display = i === 0 ? '' : 'none'; });
    setInterval(showNext, 5000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    const select = document.querySelector('[data-collection-sort]');
    if (!select) return;
    select.addEventListener('change', function () {
      this.form.submit();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const toggle = document.querySelector('[data-mobile-menu-toggle]');
    const drawer = document.querySelector('[data-mobile-drawer]');
    const closeButtons = document.querySelectorAll('[data-mobile-drawer-close]');
    if (!toggle || !drawer) return;
    function open() {
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    toggle.addEventListener('click', open);
    closeButtons.forEach(function (btn) { btn.addEventListener('click', close); });
    drawer.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', close);
    });

    function updateCartCount(itemCount) {
      const desktopLink = document.querySelector('.header__cart-link');
      const drawerLink = document.querySelector('.header-drawer__cart-link');
      function setOrCreateCount(link, className) {
        if (!link) return;
        let span = link.querySelector('.' + className);
        if (itemCount > 0) {
          if (!span) {
            span = document.createElement('span');
            span.className = className;
            span.setAttribute('aria-hidden', 'true');
            link.appendChild(span);
          }
          span.textContent = itemCount;
        } else if (span) {
          span.remove();
        }
      }
      setOrCreateCount(desktopLink, 'header__cart-count');
      setOrCreateCount(drawerLink, 'header-drawer__cart-count');
    }

    window.addEventListener('cart:updated', function (e) {
      const itemCount = e.detail && typeof e.detail.item_count === 'number' ? e.detail.item_count : 0;
      updateCartCount(itemCount);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
